import { brandingConfig } from "../../config/branding";

export default function AccessibilityStatementPage() {
  return (
    <div className="bg-gray-50 min-h-screen pt-20">
      <section className="bg-gradient-to-r from-indigo-700 via-purple-700 to-indigo-800 py-20 px-4 text-white text-center">
        <h1 className="text-4xl font-bold mb-2">Accessibility Statement</h1>
        <p className="text-lg max-w-2xl mx-auto">
          {brandingConfig.siteTitle} is committed to making its website and
          curriculum accessible to everyone, including individuals with
          disabilities.
        </p>
      </section>

      <section className="py-16 px-6 max-w-4xl mx-auto space-y-10 text-gray-700 text-sm">
        <div>
          <h2 className="text-xl font-semibold text-indigo-700 mb-2">
            Our Commitment
          </h2>
          <p>
            We strive to ensure that our platform is fully inclusive and usable
            by all learners and educators, regardless of ability. We aim to meet
            or exceed the standards defined by the Web Content Accessibility
            Guidelines (WCAG) 2.1, Level AA.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-indigo-700 mb-2">
            Steps We Take
          </h2>
          <ul className="list-disc list-inside ml-4">
            <li>Responsive layouts and keyboard-navigable design</li>
            <li>Alt text on all essential images</li>
            <li>High contrast colors and legible font choices</li>
            <li>Support for screen readers and assistive technologies</li>
            <li>Captioned videos and accessible assessments</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-indigo-700 mb-2">
            Ongoing Improvements
          </h2>
          <p>
            Accessibility is a continuous process. We regularly review our site
            and applications for potential improvements and encourage feedback
            to help us identify and address accessibility barriers.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-indigo-700 mb-2">
            Third-Party Tools
          </h2>
          <p>
            While we strive to ensure full accessibility, some content or tools
            integrated into our platform (e.g., third-party simulations) may not
            yet meet our accessibility standards. We are actively working with
            vendors to improve compliance.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-indigo-700 mb-2">
            Contact Us
          </h2>
          <p>
            If you encounter any accessibility barriers or need additional
            support, please contact our team:
          </p>
          <p className="mt-2">
            {brandingConfig.siteTitle}
            <br />
            2380 California Street, #402
            <br />
            San Francisco, CA 94115
            <br />
            Email:{" "}
            <a
              href="mailto:hello@startupsmartup.com"
              className="text-indigo-600 underline"
            >
              hello@startupsmartup.com
            </a>
          </p>
        </div>

        <div className="text-xs text-gray-500">
          Effective Date: April 10, 2025 — Last Updated: April 10, 2025
        </div>
      </section>
    </div>
  );
}
